import axios, { AxiosInstance } from 'axios';
import { config } from '../config';
import { readStoredUser } from '../utils/storage';

class HttpService {
  private readonly axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: config.apiUrl,
      headers: {
        'Content-Type': 'application/json',
        'x-dashboard-version': 'VERACONNECT-HR',
      },
      timeout: 30000,
    });

    this.axiosInstance.interceptors.request.use((requestConfig) => {
      const user = readStoredUser();
      if (user?.token) {
        requestConfig.headers.Authorization = `Bearer ${user.token}`;
      }
      return requestConfig;
    });
  }

  public get instance() {
    return this.axiosInstance;
  }
}

export const httpService = new HttpService().instance;
